import { LocationStrategy } from "@angular/common";
import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from "@angular/core";
import { MatTabGroup } from "@angular/material/tabs";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { SistemaService } from "@servicios/Sistema.Service";
import { PeriodoEvaluacion } from "@modelo/proceso/periodoevaluacion.model";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AppService } from "@api";
import { PreparacionEvaluacion } from "@modelo/proceso/preparacionpuesto.model";
import { PreparacionPreguntaOpcionalEvaluacionComponent } from "./seccion/preparacionevaluacionpregunta_opcional.component";
import { EvaluacionComponent } from "@contenido/AppContent/global/evaluacion/evaluacion.component";
import { Evaluacion } from "@modelo/global/Evaluacion.model";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { EvaluacionPendientePrevisualizarComponent } from "@contenido/AppContent/evaluacionpendiente/colaborador/previsualizar/previsualizar.component";


@Component({
    selector: 'prepacionpreguntageneral',
    templateUrl: './preparacionevaluaciopregunta.component.html',
    styleUrls: ['../preparacionevaluacion.component.scss']
})

export class PreparacionEvaluacionPreguntaGeneral implements OnInit, AfterViewInit{
    entidad: PeriodoEvaluacion;
    entidadpuesto: PreparacionEvaluacion;
    consulta!: boolean;
    @ViewChild('tab') private tab!: MatTabGroup;
    @ViewChild('general') private preparaciongeneralComponent!: PreparacionPreguntaOpcionalEvaluacionComponent;

    @Input() accion!: {accionid: number, accion: string};
    @Input() idpuesto!: number;
    @Input() idperiodoevaluacion!: number;
    @Input() iddepartamento!: number;
    @Output() output = new EventEmitter();

    @ViewChild("containerEvaluacion", {read: ViewContainerRef}) containerEvaluacion!: ViewContainerRef;

    cambio: boolean = false;
    public errorActivo!: boolean;
    constructor(private appService: AppService,private location: LocationStrategy, public sistemaService: SistemaService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver){
        this.entidad = new PeriodoEvaluacion();
        this.entidadpuesto = new PreparacionEvaluacion();
        history.pushState(null, "", window.location.href);
        this.location.onPopState(() => {
            this.Salir();
        });
    }

    ngOnInit(){
    }

    ngAfterViewInit(){
        this.SetPeriodoEvaluacion();
        // 1. Save the click handler for later
        const handleTabClick = this.tab._handleClick;

        // 2. Replace the click handler with our custom function
        this.tab._handleClick = (tab, header, index) => {
            switch (this.tab.selectedIndex) {
                case 0:
                case 1:
                case 2:
                case 3:
                    handleTabClick.apply(this.tab, [tab, header, index]);
                    break;
            }
        };
    }

    SetPeriodoEvaluacion(){
        this.appService.Post("planeacion/periodoevaluacion/buscar", {"periodoevaluacionid":this.idperiodoevaluacion}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.entidad = new PeriodoEvaluacion(res.data[0]);
                this.SetPuesto();
            }
        })
    }

    SetPuesto(){
        this.appService.Post("planeacion/preparacionevaluacion/preparacion/puesto/uno",{"puestoid": this.idpuesto, "departamentoid":this.iddepartamento, "periodoevaluacionid":this.idperiodoevaluacion}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.entidadpuesto = new PreparacionEvaluacion(res.data[0])
                this.entidadpuesto.periodoevaluacionid = this.entidad.periodoevaluacionid;
                if(this.entidadpuesto.fechaedicion){
                    this.entidadpuesto.fechaedicion = this.formatDate(this.entidadpuesto.fechaedicion);
                }
                this.entidadpuesto.usuarioanterior = res.data[0].usuario;
            }
        })
    }

    formatDate(date: string) {
        let valor = date.split("/");
        let año = valor[2].split(" ");
        let fecha = año[0] + "-" + valor[1] + "-" + valor[0];
        return fecha;
    }

    Guardar(){
        this.preparaciongeneralComponent.Guardar().then(res=>{
            this.Salir();
        });
    }

    Previsualizar(){
        this.preparaciongeneralComponent.Guardar().then(res=>{
            if(res.valor){
                let entidadtemporal = new Evaluacion();
                entidadtemporal.periodoevaluacionid = this.entidad.periodoevaluacionid;
                entidadtemporal.departamentoevaluadorid = this.entidadpuesto.departamentoid;
                entidadtemporal.periodoevaluacion = this.entidad.descripcion;
                entidadtemporal.departamento = this.entidadpuesto.departamento;
                entidadtemporal.puesto = this.entidadpuesto.nombre;
                entidadtemporal.puestoevaluadorid = this.entidadpuesto.puestoid;
                entidadtemporal.colaboradorrelacionid = 2;
                entidadtemporal.tipovisualizacioncompetenciacriterioid = 2;
                entidadtemporal.tipovisualizacionpreguntaid = 2;
                entidadtemporal.tipovisualizacionrespuestaid = 2;
                this.consulta = true;
                this.containerEvaluacion.clear();
                const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(EvaluacionPendientePrevisualizarComponent);
                var ref: ComponentRef<any> = this.containerEvaluacion.createComponent(factory);
                ref.instance.entidad = entidadtemporal;
                ref.instance.output.subscribe((cambio: boolean) => {
                    this.consulta = false;
                    ref.destroy();
                    if (cambio) {

                    }
                });
            }
        });

    }

    Salir() {
        this.cambio = true;
        this.output.next(this.cambio);
    }
}